// Live lock/unlock of the Specialties assignment list on the Medical Search Term
// edit form, driven by the specialties_under_client_control toggle — no save required.
//
// Server-rendered contract (see Admin::MedicalSearchTermsController#association_configuration
// and Admin::MedicalSearchTermsHelper):
// - The list always renders fully interactive markup for canonical terms.
// - The list wrapper carries `client-specialties-lockable`, plus `client-specialties-locked`
//   when the saved flag is off (initial state, so there is no unlock flash on load).
// - Both info messages render, each in a `[data-role]` wrapper with `hidden` reflecting
//   the saved state.
//
// This behaviour keeps that state in sync with the checkbox:
// - `client-specialties-locked` hides the add UI (#specialty_search) and the per-item
//   delete controls via admin/_assignment-list.scss.
// - Age-group selects use their `disabled` property.
// - The lock warning and the client-control notice swap visibility.
// Rank inputs are deliberately left alone — ranks stay editable on canonical terms.
jQuery(function () {
  var selector = '[data-behaviour~="client-specialties-toggle"]';

  jQuery(document).on("change", selector, applyState);

  // Locked age-group selects render disabled server-side. Initialize the wrapper
  // classes and message visibility from the same saved state.
  jQuery(selector).each(applyState);

  function applyState() {
    var checkbox = jQuery(this);
    var unlocked = checkbox.is(":checked");
    var container = checkbox.closest(".client-specialties-lockable");

    container.toggleClass("client-specialties-locked", !unlocked);

    for (const control of container[0].querySelectorAll('[name^="age_group_specialty_assignment"]')) {
      control.disabled = !unlocked;
    }

    // The two messages render as the list's before_content — siblings of the lockable
    // wrapper, not children — so scope through the wrapper's parent rather than the
    // document to avoid flipping unrelated [data-role] markup elsewhere on the page.
    var messageScope = container.parent();
    messageScope.find('[data-role~="canonical-specialties-lock-warning"]').prop("hidden", unlocked);
    messageScope.find('[data-role~="client-specialties-notice"]').prop("hidden", !unlocked);
  }
});
